import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import ButtonFilter from './FilterComponents/CoreComponents/ButtonFilter';

import styles from '../search.scss';

const ClubMemberTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, handleMemberTypeClick, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'memberType'}
                isActive={(filters && filters.clubMemberTypeId) || filterModal === 'memberType'}
                handleFilterClick={handleFilterClick}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Type{filters && filters.clubMemberTypeId ? `: ${filters.clubMemberTypeId === 2 ? ' Digital' : 'Physical'}` : ''}
            </Filter>
            {filterModal === 'memberType' && (
                <FilterModal
                    title={'Digital / Physical'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <ButtonFilter
                            options={[
                                { label: 'All', value: '' },
                                { label: 'Digital', value: 2 },
                                { label: 'Physical', value: '1' },
                            ]}
                            selected={filterInputs.clubMemberTypeId}
                            onClick={handleMemberTypeClick}
                            autoSubmit={true}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />

                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default ClubMemberTypeFilter;
